<div id="wrapper"class="health-examiner" (window:resize)="util.addPerfectScrollBar()">
    <!--Header-->
    <app-header></app-header>
    <div class="wrapper-body scrollbar">
        <!--Router-outlet-->
        <router-outlet></router-outlet>
        <!--Footer-->
        <app-footer></app-footer>
    </div>
</div>